import * as canvas from 'canvas'
import Wob from './wob'
import _ from 'lodash'
import MockSync from 'scoreboard/components/mock-sync'
import widgetTypes from '../widgets/all'

var Wobs = canvas.Wobs.extend({
	// use a mocked sync so that changes aren't sent to the server immediately
	sync: MockSync,
	model: Wob,

	// Returns all dashboard node data required for saving to the server or retrieving fresh domain object data
	// Example:
	//	[
	//		{
	//			id: 45514028,
	//			cid: "c1234",
	//			height: 200,
	//			width: 200
	//			left: 100,
	//			top: 100,
	//			zindex: 2,
	//			properties: {type: "speedometer", domainObjectId: "7081", showLabel: true}
	//		},
	//		{
	//			height: 200,
	//			width: 200
	//			left: 100,
	//			top: 100,
	//			zindex: 2,
	//			properties: {type: "image"},
	//			image: {
	//				name: "whatever.jpg",
	//				dataUri: "data:image/jpeg;base64,/9j/4AAQSkZJR"
	//			}
	//		}
	//	]
	widgets: function () {
		return this.chain()
			.map(function (wob) {
				var wobOnly = _.pick(wob.attributes,
					'id', 'left', 'top', 'width', 'height', 'thresholdColoring',
					'outlineWidth', 'outlineColor', 'levitated', 'locked', 'syncId')
				wobOnly.cid = wob.cid // Send this to the server so new wobs with connectors can be associated correctly.
				wobOnly.zindex = wob.get('z-index')
				wobOnly.rotation = wob.get('rotate')

				wobOnly.connectors = _.isNil(wob.get('connectors')) ? [] : wob.get('connectors').toJSON()
					.filter(function (connector) {
						return connector.to
					})
					.map(function (connector) {
						return {
							id: connector.id,
							opacity: connector.style.opacity,
							'strokeWidth': connector.style['stroke-width'], // B/c this is easy than figuring out the java
							'strokeDasharray': connector.style['stroke-dasharray'], // see above
							toId: connector.to.id,
							toCid: connector.to.cid, // In case the `to` doesn't have an ID yet
							fromId: wobOnly.id,
							control: connector.control
						}
					})

				return  _.extend(
					wobOnly,
					{
						properties: wob.widget.attributes.properties,
						// #60122 image could be on the widget attributes OR on
						// the wob attributes (if it's an unsaved form dashboard)
						image: wob.widget.attributes.image || wob.attributes.image,
						oldChart: wob.widget.oldChart ? wob.widget.oldChart.toPostJSON() : null,
						chart: wob.widget.chart ? wob.widget.chart.toPostJSON() : null,
						report: wob.widget.report ? wob.widget.report.toJSON() : null,
						table: wob.widget.table ? wob.widget.table.toJSON(): null
					})
			}).value()
	}
})

function createWobs ({ dashboardModel, organizationId, getPeriodId, wobData }) {
	return new Wobs(
		wobData ?? dashboardModel.wobData(),
		{
			dashboardId: dashboardModel.get('id'),
			widgetTypes,
			section: dashboardModel.get('section'),
			getPeriodId,
			parentData: dashboardModel.data,
			// Needed for #23072, see report-widget-model.js:initialize for explanation
			organizationId
		}
	)
}

export default Wobs
export { createWobs }

Wobs.__filename__ = 'dashboards/display/wobs.js'
